import { render, staticRenderFns } from "./OneDayAddV5Covit.vue?vue&type=template&id=a646f0bc&"
import script from "./OneDayAddV5Covit.vue?vue&type=script&lang=ts&"
export * from "./OneDayAddV5Covit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports